import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updatePrice
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:143
* @route '/bookings/{booking}/activities/{activity}/additional-price'
*/
export const updatePrice = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePrice.url(args, options),
    method: 'put',
})

updatePrice.definition = {
    methods: ["put"],
    url: '/bookings/{booking}/activities/{activity}/additional-price',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updatePrice
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:143
* @route '/bookings/{booking}/activities/{activity}/additional-price'
*/
updatePrice.url = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            activity: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
        activity: typeof args.activity === 'object'
        ? args.activity.id
        : args.activity,
    }

    return updatePrice.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{activity}', parsedArgs.activity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updatePrice
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:143
* @route '/bookings/{booking}/activities/{activity}/additional-price'
*/
updatePrice.put = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePrice.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updatePrice
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:143
* @route '/bookings/{booking}/activities/{activity}/additional-price'
*/
const updatePriceForm = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePrice.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updatePrice
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:143
* @route '/bookings/{booking}/activities/{activity}/additional-price'
*/
updatePriceForm.put = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePrice.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updatePrice.form = updatePriceForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updateDate
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:122
* @route '/bookings/{booking}/activities/{activity}/date'
*/
export const updateDate = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateDate.url(args, options),
    method: 'put',
})

updateDate.definition = {
    methods: ["put"],
    url: '/bookings/{booking}/activities/{activity}/date',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updateDate
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:122
* @route '/bookings/{booking}/activities/{activity}/date'
*/
updateDate.url = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            activity: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
        activity: typeof args.activity === 'object'
        ? args.activity.id
        : args.activity,
    }

    return updateDate.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{activity}', parsedArgs.activity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updateDate
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:122
* @route '/bookings/{booking}/activities/{activity}/date'
*/
updateDate.put = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateDate.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updateDate
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:122
* @route '/bookings/{booking}/activities/{activity}/date'
*/
const updateDateForm = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateDate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::updateDate
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:122
* @route '/bookings/{booking}/activities/{activity}/date'
*/
updateDateForm.put = (args: { booking: string | number | { booking_reference: string | number }, activity: string | { id: string } } | [booking: string | number | { booking_reference: string | number }, activity: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateDate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateDate.form = updateDateForm

const activities = {
    updatePrice: Object.assign(updatePrice, updatePrice),
    updateDate: Object.assign(updateDate, updateDate),
}

export default activities